import Section from '../containers/Section'
import SectionForCession from '../containers/SectionDetailForCession'
import Login from '../containers/Login'
import SectionDetail from '../containers/SectionDetail'

const routes = [
  {
    path: '/',
    name: 'commands-list',
    component: Section,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/#/command/list',
    redirect: '/'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'logout'
  },
  {
    path: '/cession/list',
    name: 'CessionsList',
    component: Section,
    meta: {
      name: 'cession-list',
      requiresAuth: true
    }
  },
  {
    path: '/cession/:id',
    name: 'recapitulatif-cession',
    component: SectionForCession,
    meta: {
      requiresAuth: true,
      name: 'recapitulatif-cession'
    }
  },
  {
    path: '/expertises',
    name: 'expertises',
    component: Section,
    meta: {
        requiresAuth: true,
        name: 'Expertises'
    },
    children: [
      {
        path: 'create',
        name: 'expertise-create',
        meta: {
            requiresAuth: true,
            name: 'Nouveau RDV'
        }
      }
    ]
  },
  {
    path: '/command/create*',
    name: 'command-create',
    component: Section,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/command/:id',
    name: 'command-details-recapitulatif',
    component: SectionDetail,
    meta: {
      requiresAuth: true,
      name: 'Récapitulatif'
    },
    children: [
      {
        path: 'success*',
        name: 'command-details-recapitulatif-success',
        meta: {
            name: 'Récapitulatif'
        },
      },
      {
        path: 'error*',
        name: 'command-details-recapitulatif-error',
        meta: {
            name: 'Récapitulatif'
        },
      },
      {
        path: 'cancel*',
        name: 'command-details-recapitulatif-cancel',
        meta: {
            name: 'Récapitulatif'
        },
      },
      {
        path: 'proprietaire-actuel',
        name: 'command-details-proprietaire-actuel',
        meta: {
          name: 'Propriétaire actuel'
        },
      },
      {
        path: 'futur-proprietaire',
        name: 'command-details-futur-proprietaire',
        meta: {
          name: 'Futur propriétaire'
        },
      },
      {
        path: 'cession',
        name: 'command-details-cession',
        meta: {
          name: 'RDV de cession'
        },
      },
      {
        path: 'documents',
        name: 'command-details-documents',
        meta: {
          name: 'Documents'
        }
      },
      {
        path: 'delivery-light',
        name: 'command-details-delivery-light',
        meta: {
          name: 'Livraison'
        },
      },
      {
        path: 'lemonway',
        name: 'command-details-lemonway',
        meta: {
          name: 'Lemonway'
        }
      },
      {
        path: 'lemonwayB',
        name: 'command-details-lemonway-b',
        meta: {
          name: 'Lemonway'
        }
      },
      {
        path: 'credit',
        name: 'command-details-credit',
        meta: {
          name: 'credit'
        }
      },
      {
        path: 'LemonwayCredit',
        name: 'command-details-virement-lemonway',
        meta: {
          name: 'LemonwayCredit'
        }
      },
      {
        path: 'LemonwayCreditB',
        name: 'command-details-virement-lemonway-b',
        meta: {
          name: 'LemonwayCredit'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default routes
